const toast = useToast
export { toast }
export { useFetchAPI, useCustomFetch } from './api/useFetchAPI'
export { crudIndexInfiniteQuery } from './crud/crud.index'
export { getArticlesPressReview } from './article/article'
export { sortArticlesByPosition } from './article/sortArticles'
export { HttpMethod } from '~/constants/method'
export { KeyCode } from '~/constants/keyCode'
export { NavigationDirection } from '~/enums/navigation-direction.enums'
export { ResponseType } from '~/constants/response'
export { mappingCategory } from '~/composables/category/mappingCategory'
export { childrenCategoryHaveArticles } from '~/composables/category/childrenCategoryHaveArticles'
export { TypeUpdateRootCategory } from '~/enums/type-update-root-category.enum'
export { updateRootCategoryByAction } from '~/composables/category/updateRootCategory'
export { buildFiltersQueryArticle } from '~/composables/article/build-filters-query'

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'remove', {
  value: function (from: number, to: number) {
    const rest = this.slice((to || from) + 1 || this.length)
    this.length = from < 0 ? this.length + from : from
    return (this as []).push.apply(this, rest)
  }
})
